import { render, staticRenderFns } from "./RoleListPage.vue?vue&type=template&id=5b913ee1&"
import script from "./RoleListPage.vue?vue&type=script&lang=js&"
export * from "./RoleListPage.vue?vue&type=script&lang=js&"
import style0 from "./RoleListPage.vue?vue&type=style&index=0&id=5b913ee1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports